/* shah */
import React from 'react'

const CenterIcon = () => {
    return (
        <svg id="SmallBoxSVG-center" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M555 4461 c-83 -38 -125 -103 -125 -193 1 -100 64 -184 156 -207 61
-16 3887 -15 3949 0 99 25 161 117 153 228 -5 78 -41 131 -111 166 l-51 25
-1965 0 c-1886 0 -1968 -1 -2006 -19z"/>
                <path d="M1179 3317 c-64 -34 -102 -93 -107 -166 -7 -101 33 -176 113 -212 38
-18 101 -19 1375 -19 1274 0 1337 1 1375 19 80 36 120 111 113 212 -5 73 -43
132 -107 166 l-44 23 -1337 0 -1337 0 -44 -23z"/>
                <path d="M545 2181 c-80 -36 -120 -111 -113 -212 5 -73 43 -132 107 -166 l44
-23 1977 0 1977 0 44 23 c64 34 102 93 107 166 7 101 -33 176 -113 212 -38 18
-120 19 -2015 19 -1895 0 -1977 -1 -2015 -19z"/>
                <path d="M1217 1057 c-89 -28 -146 -108 -147 -205 0 -90 42 -155 125 -193 38
-18 101 -19 1366 -19 l1325 0 51 25 c68 34 105 90 111 168 8 109 -54 201 -153
226 -64 16 -2625 14 -2678 -2z"/>
            </g>
        </svg>

    )
}

export default CenterIcon